// extracted by mini-css-extract-plugin
export default {"error":"InfoBox__error-d_YWI","info":"InfoBox__info-qfjVd","success":"InfoBox__success-LuxCi"};